import React from "react";
import ArticleLaunchCard from "../components/ArticleLaunchCard";

import styles from "./ArticlesGrid.module.css";

export default function ArticlesGrid({
  articles,
  langKey,
  withFeatured = true,
  inBeetween,
}) {
  const [featured, ...others] = articles;

  return (
    <div>
      {withFeatured && (
        <div>
          <ArticleLaunchCard
            to={featured.fields.postPath}
            title={featured.frontmatter.title}
            subtitle={featured.frontmatter.subtitle}
            featuredImage={featured.frontmatter.featuredImage}
            featured
            authors={featured.frontmatter.authors}
            date={featured.fields.date}
            minutesRead={featured.timeToRead}
            langKey={langKey}
          />
        </div>
      )}
      {inBeetween}
      <div className={styles.articleGrid}>
        {(withFeatured ? others : articles).map((node) => (
          <ArticleLaunchCard
            key={node.id}
            to={node.fields.postPath}
            title={node.frontmatter.title}
            subtitle={node.frontmatter.subtitle}
            featuredImage={node.frontmatter.featuredImage}
            authors={node.frontmatter.authors}
            date={node.fields.date}
            minutesRead={node.timeToRead}
            langKey={langKey}
          />
        ))}
      </div>
    </div>
  );
}
